var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSparkles = function SvgSparkles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 36,
    height: 42,
    viewBox: "0 0 1.44 1.7",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.75.49.79.47C.9.41.9.27.9.25c-.02-.26.1-.21.19-.04l.02.05c.03.08.06.15.13.18.03.02.06.02.08.02.04.01.07.01.09.06.05.07.03.11-.05.15-.06.04-.09.06-.12.09-.01.02-.03.06-.05.12 0 .02-.01.04-.01.06l.01.02c0 .04-.01.08-.02.1h-.01c-.07.09-.15.09-.18-.06V.96A.712.712 0 0 0 .89.79C.85.73.78.73.75.73.7.73.68.73.64.69.57.6.62.57.75.49zM.13.23.15.22C.2.2.2.14.2.14c.05-.2.16-.18.21.02.01.04.02.07.04.08.01.01.02.02.03.02.04.01.06.02.08.06C.59.4.57.43.49.46.46.48.44.48.43.49.42.5.41.51.4.54L.39.56v.01C.39.61.37.64.36.66.27.74.19.73.19.58V.55C.18.54.18.51.16.47.15.45.12.45.11.45.07.44.05.44.03.39-.03.29.01.27.13.23zm.64 1.13-.04.01c-.1.04-.11.16-.11.17 0 .22-.16.21-.2.03l-.01-.05c-.02-.07-.04-.14-.09-.17a.207.207 0 0 0-.06-.02c-.04-.01-.07-.02-.09-.07-.03-.07-.01-.11.07-.14.05-.03.09-.05.11-.06.01-.02.03-.05.05-.11C.41.93.41.92.42.91L.41.89c0-.04.02-.08.04-.1C.53.71.61.72.62.87v.04c.01.03.02.08.06.15.02.05.09.06.11.06.04.01.07.01.1.05v.01c.06.1.01.12-.12.18z",
    fill: "#000"
  })));
};

export default SvgSparkles;